import { IAppState } from 'src/store/types';

export const getInfrastructureRequestData = (state: IAppState) => state.requests.infrastructure.data;
export const getInfrastructureRequestLoading = (state: IAppState) => state.requests.infrastructure.isLoading;
export const getInfrastructureRequestErrors = (state: IAppState) => state.requests.infrastructure.error;
